/* eslint-disable @typescript-eslint/no-non-null-assertion */
/* eslint-disable no-unused-expressions */
import { KeyboardEvent, useCallback } from "react";
import { Controller, useForm } from "react-hook-form";
import * as MUI from "@mui/material";
import * as MUIcons from "@mui/icons-material";

import { criminalStoreRC } from "../../../hooks/store";
import { useAuth } from "../../../hooks/auth";

import { LayoutConsultaCriminal } from "./LayoutConsultaCriminal";
import { ResultadoConsultaCriminal } from "../../../components";

type InputProps = {
  rc: string;
};

export const FiltroCriminalRC: React.FC = () => {
  const { control, handleSubmit } = useForm<InputProps>({
    defaultValues: {
      rc: "",
    },
  });

  const { user } = useAuth();

  const { url } = user!.sistemas.filter((s) => {
    return s.id_sistema === 9 ? s.url : false;
  })[0];

  const {
    consultaCriminalRC,
    resultadoCriminalRC,
    mensagemCriminal,
    limparConsultaCriminalRC: limparConsultaCriminal,
  } = criminalStoreRC((state) => state.criminal);
  const { loading } = criminalStoreRC((state) => state.global);

  const pesquisaCriminalRC = (data: InputProps) => {
    consultaCriminalRC(url, data.rc);
  };

  const keyBoardClick = useCallback((e: KeyboardEvent<HTMLInputElement>) => {
    e.key === "Enter";
  }, []);

  return (
    <LayoutConsultaCriminal>
      <MUI.Grid
        component="form"
        alignItems="center"
        width={["100%", "100%", "100%", "80%", "60%"]}
        container
        spacing={1}
        onSubmit={handleSubmit(pesquisaCriminalRC)}
      >
        <MUI.Grid item xs={12} md={4} sm={4}>
          <Controller
            name="rc"
            control={control}
            render={({ field: { value, onChange } }) => (
              <MUI.TextField
                label="Informe o Registro Criminal"
                value={value.replace(/\D/g, "")}
                onChange={onChange}
                onKeyPress={keyBoardClick}
                fullWidth
                size="small"
                disabled={loading}
              />
            )}
          />
        </MUI.Grid>

        <MUI.Grid item xs={12} md={3} sm={3}>
          <MUI.Button
            fullWidth
            variant="contained"
            color="primary"
            type="submit"
            disabled={loading}
            startIcon={<MUIcons.Search />}
          >
            <MUI.Typography
              variant="button"
              whiteSpace="nowrap"
              textOverflow="ellipsis"
              overflow="hidden"
            >
              Consultar
            </MUI.Typography>
          </MUI.Button>
        </MUI.Grid>

        <MUI.Grid item xs={12} md={3} sm={3}>
          <MUI.Button
            fullWidth
            variant="outlined"
            color="secondary"
            onClick={limparConsultaCriminal}
            disabled={loading}
            startIcon={<MUIcons.Clear />}
          >
            <MUI.Typography
              variant="button"
              whiteSpace="nowrap"
              textOverflow="ellipsis"
              overflow="hidden"
            >
              Limpar resultado
            </MUI.Typography>
          </MUI.Button>
        </MUI.Grid>
      </MUI.Grid>
      <MUI.Stack>
        {resultadoCriminalRC || mensagemCriminal ? (
          <MUI.Typography variant="h6">Resultado da consulta:</MUI.Typography>
        ) : (
          false
        )}

        {!loading ? (
          (resultadoCriminalRC &&
            resultadoCriminalRC?.map((cidadao) => (
              <ResultadoConsultaCriminal
                key={cidadao.NumeroPedido}
                infoNome={cidadao.Nome}
                infoMae={cidadao.Mae}
                infoPai={cidadao.Pai}
                to={`consulta-criminal/ficha-criminal/${cidadao.NumeroPessoa}`}
              />
            ))) || (
            <MUI.Typography variant="h6">{mensagemCriminal}</MUI.Typography>
          )
        ) : (
          <MUI.LinearProgress />
        )}
      </MUI.Stack>
    </LayoutConsultaCriminal>
  );
};
